import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, Notifications } from '@mui/icons-material';
import { ArrowBack, Share, Favorite, FavoriteBorder } from '@mui/icons-material';
import api from '../utils/api';

const Header = ({ toggleMenu }) => {
    const isAuthenticated = !!localStorage.getItem('token');
    const location = useLocation();
    const [hasUnread, setHasUnread] = useState(false);
    const [hasAny, setHasAny] = useState(false);
    const lastFetchRef = useRef(0);
 
    const navigate = useNavigate();
    const getPageTitle = (pathname) => {

        const route = pathname.split("/")[1] === "dashboard" ? `/dashboard/${pathname.split("/")[2]}` : pathname.split("/")[1];
        const routes = {
            '': 'پیشخوان رفاهی',
            "assistant":"دستیار هوشمند",
            "welfare-categories": 'دسته‌بندی‌های رفاهی',
            "welfare": 'مشاغل طرف قرارداد',
            "news": 'اخبار و اطلاعیه‌ها',
            'events': 'مراسمات و رویدادها',
            'contact': 'تماس با ما',
            'profile': 'پروفایل کاربری',
            'retraining': 'بازآموزی',
            'board-members': 'اعضای هیئت مدیره',
            'admins': 'اعضای هیت مدیره',
            'complete-profile': 'تکمیل اطلاعات',
            'settings': 'تنظیمات برنامه',
            'dashboard/retraining': 'مدیریت دوره‌ها',
            'dashboard/users-management': 'مدیریت کاربران',
            'dashboard/welfare-categories': 'مدیریت دسته‌بندی‌های رفاهی',
            'dashboard/slider': 'مدیریت اسلایدر',
            'dashboard/notifications': 'مدیریت اعلان‌ها',
            'notifications': 'اعلان‌ها',
        };
        return routes[route] || '';
    };

    const displayBackButton = (pathname) => {
        const route = pathname.split("/")[1] === "dashboard" ? `/dashboard/${pathname.split("/")[2]}` : pathname.split("/")[1];
        const allowedBack = ["welfare", "newsdetail", "eventdetail", "/dashboard/ratings"];
        return allowedBack.includes(route) || Boolean(location.state?.fromAssistant);
    };

    const handleBackClick = () => {
        if (location.state?.fromAssistant) {
            navigate('/assistant');
            return;
        }
        if (location.state?.fromServicesList) {
            navigate(-1);
            return;
        }
        if (location.pathname.startsWith('/welfare')) {
            navigate('/welfare-categories');
            return;
        }
        navigate(-1);
    };
    useEffect(() => {
        if (!isAuthenticated) return;
        const now = Date.now();
        if (now - lastFetchRef.current < 30000) return;
        lastFetchRef.current = now;

        let mounted = true;
        const loadCounts = async () => {
            try {
                const [unreadRes, archiveRes] = await Promise.all([
                    api.get('/notifications', { params: { limit: 1 } }),
                    api.get('/notifications/archive', { params: { limit: 1 } }),
                ]);
                const unreadList = Array.isArray(unreadRes?.data) ? unreadRes.data : [];
                const archiveList = Array.isArray(archiveRes?.data) ? archiveRes.data : [];
                if (!mounted) return;
                setHasUnread(unreadList.length > 0);
                setHasAny(unreadList.length > 0 || archiveList.length > 0);
            } catch (e) {
                if (!mounted) return;
                setHasUnread(false);
                setHasAny(false);
            }
        };

        loadCounts();
        return () => { mounted = false; };
    }, [isAuthenticated, location.pathname]);

    function testCopilot() { }
    return (
        <header className="header position-fixed header-filled" style={{
            maxHeight: 65
        }}>
            <div className="row">
                <div className="col-auto">
                    {isAuthenticated && (
                        <button
                            type="button"
                            data-react-menu-toggle
                            className="btn btn-light btn-44 btn-rounded menu-btn border-0"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu();
                            }}
                        >
                            <Menu sx={{ fontSize: 24 }} />
                        </button>
                    )}
                </div>
                <div className="col">
                    <Link to="/" className="logo-small text-decoration-none ">
                        <h6 className="px-1">
                            سازمان نظام پزشکی تبریز
                            <br />
                            <span className="text-secondary fw-light size-12">{getPageTitle(location.pathname)}</span>
                        </h6>
                    </Link>
                </div>
                {/* {isAuthenticated && (
                    <div className="col-auto">
                        <Link to="/notifications" className="btn btn-light btn-44 btn-rounded border-0">
                            <Notifications sx={{ fontSize: 24 }} />
                            <span className="count-indicator"></span>
                        </Link>
                        <Link to="/profile" className="btn btn-light btn-44 btn-rounded ms-2 border-0">
                            <Person sx={{ fontSize: 24 }} />
                        </Link>
                    </div>
                )} */}
                {displayBackButton(location.pathname) ?
                    <div className="col-auto">
                        <button
                            type="button"
                            className="btn btn-light btn-44 btn-rounded border-0"
                            onClick={handleBackClick}
                        >
                            <ArrowBack />
                        </button>
                    </div> :
                    <div className="col-auto d-flex align-items-center">
                        {isAuthenticated && hasAny && (
                            <Link
                                to="/notifications"
                                className="btn btn-light btn-44 btn-rounded border-0 position-relative me-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Notifications sx={{ fontSize: 24 }} />
                                {hasUnread && (
                                    <span
                                        style={{
                                            position: 'absolute',
                                            top: 6,
                                            left: 6,
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            backgroundColor: '#ff3b30',
                                        }}
                                    />
                                )}
                            </Link>
                        )}
                        <img src="/assets/img/logo.png" alt="" className="rounded-circle btn btn-light btn-44 btn-rounded border-0" />
                    </div>
                }

            </div>
        </header>
    );
};

export default Header;
